import styled from 'styled-components';
import { AvatarWrapper } from '../../Avatar';

const TextFieldWrapper = styled.div`
  ${AvatarWrapper} {
    margin-right: 24px;
    flex-shrink: 0;
  }
`;

export default TextFieldWrapper;
